import React, { useContext, useState } from 'react'
import { ThemeContext } from '../contexts/themeContext'
import { useSelector, useDispatch } from 'react-redux'
import { updateMatildeNotif } from '../store/actions/apiActions'
import Modal from 'react-modal'
import Button from './Button'

const SettingsMenu = props => {
    const { openState, setOpenState } = props
    const { changeFont, theme } = useContext(ThemeContext)
    const { chosenFontSize } = theme

    const dispatch = useDispatch()
    const matildeNotifications = useSelector(state => state.firebase.profile.matildeNotif)

    const initState = {
        notifications: matildeNotifications
    }

    const [state, setState] = useState(initState)

    return (
        <Modal
            isOpen={openState}
            onRequestClose={setOpenState}
            contentLabel="Modal das Configurações"
            className='modal'
            disableAutoFocus={true}
            closeTimeoutMS={500}
            ariaHideApp={false}
        >
            <div className='modal-guts block'>
                <div className='w-full'>
                    <h2>Configurações</h2>
                </div>

                <div className='py-2 flex items-center justify-between'>
                    <p className='m-0'>Balões de fala da Matilde</p>
                    <div className="relative">
                        <select
                            className="block appearance-none shadow appearance-none border rounded py-2 pl-2 pr-6 my-3"
                            onChange={(ev) => setState({ ...state, [ev.target.name]: !state.notifications })}
                            name='notifications'
                            value={state.notifications}
                        >
                            <option value='true'>Ligado</option>
                            <option value='false'>Desligado</option>
                        </select>
                        <div className="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2">
                            <svg className="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z" /></svg>
                        </div>
                    </div>
                </div>

                <div className='pt-5 flex float-right'>
                    <Button
                        className='mr-5'
                        onClick={() => {
                            setOpenState()
                            setState({ state, initState })
                        }}
                    >
                        Fechar
                    </Button>
                    <Button
                        className='mr-0'
                        onClick={() => {
                            changeFont(state.fontSize)
                            dispatch(updateMatildeNotif(state.notifications))
                            setOpenState()
                        }}
                    >
                        Salvar
                    </Button>
                </div>
            </div>
        </Modal >
    )
}

export default SettingsMenu